const fallbackPartnerLinks = [
  {
    id: 'fallback-hubstudio',
    name: { 'zh-cn': 'Hubstudio', en: 'Hubstudio' },
    description: { 'zh-cn': '', en: '' },
    url: 'https://www.hubstudio.com/register/?ref=7VK9Og2t',
    icon: require('@/assets/index/img/parters/hubstudio.png'),
    alt: 'Hubstudio',
    rel: 'noopener noreferrer',
  },
  {
    id: 'fallback-ziniao',
    name: { 'zh-cn': '紫鸟浏览器', en: 'Superbrowser' },
    description: { 'zh-cn': '', en: '' },
    url: 'https://www.ziniao.com/',
    icon: require('@/assets/index/img/parters/ziniao.png'),
    alt: 'Ziniao',
    rel: 'noopener noreferrer',
  },
  {
    id: 'fallback-tkspmall',
    name: { 'zh-cn': '跨境百宝箱', en: 'tkspmall' },
    description: { 'zh-cn': '', en: '' },
    url: 'https://www.tkspmall.com/?affId=Qo0u1AXhMW',
    icon: require('@/assets/index/img/parters/tkspmall.jpg'),
    alt: 'tkspmall',
    rel: 'noopener noreferrer',
  },
  {
    id: 'fallback-fasttk',
    name: { 'zh-cn': 'FastTK', en: 'FastTK' },
    description: { 'zh-cn': '', en: '' },
    url: 'https://www.fasttk.com/?affId=Qo0u1AXhMW',
    icon: require('@/assets/index/img/parters/fasttk.jpg'),
    alt: 'FastTK',
    rel: 'noopener noreferrer',
  },
  {
    id: 'fallback-vmcard',
    name: { 'zh-cn': '虚拟卡', en: 'Virtual Card' },
    description: { 'zh-cn': '', en: '' },
    url: 'https://vmcardio.com/zh/register?code=036860',
    icon: require('@/assets/index/img/parters/vmcard.jpg'),
    alt: 'Virtual Card',
    rel: 'noopener noreferrer',
  },
  {
    id: 'fallback-duoplus',
    name: { 'zh-cn': 'DuoPlus云手机', en: 'DuoPlus Cloud Phone' },
    description: { 'zh-cn': '', en: '' },
    url: 'https://www.duoplus.net/share/sparkproxy',
    icon: require('@/assets/index/img/parters/duoplus.jpg'),
    alt: 'DuoPlus',
    rel: 'noopener noreferrer',
  },
  {
    id: 'fallback-mulogin',
    name: { 'zh-cn': '多登防关联浏览器', en: 'MuLogin' },
    description: { 'zh-cn': '', en: '' },
    url: 'https://www.mulogin.com/?ref=sparkproxy',
    icon: '/uploads/20260611/9b37c56dd35cb536e5f361a12abc75d4.jpg',
    alt: '多登防关联浏览器',
    rel: 'noopener noreferrer',
  },
]

let capturedPartnerLinksHtml = ''

export function capturePartnerLinksHtml(documentRef = document) {
  const host = documentRef && documentRef.querySelector('[data-partner-links-host]')
  if (!host || !host.querySelector('.partner-card[href], [data-partner-links-empty]') || host.querySelector('script')) {
    capturedPartnerLinksHtml = ''
    return capturedPartnerLinksHtml
  }

  capturedPartnerLinksHtml = host.innerHTML.trim()
  return capturedPartnerLinksHtml
}

export function getCapturedPartnerLinksHtml() {
  return capturedPartnerLinksHtml
}

export function getFallbackPartnerLinks() {
  return fallbackPartnerLinks.map(item => ({
    ...item,
    name: { ...item.name },
    description: { ...item.description },
  }))
}
